<template>
  <div class="audit-manager-container">
    <div class="zhanwei4"></div>

    <!-- 顶部状态栏与统计引导 -->
    <div class="audit-header-panel">
      <div class="header-left">
        <h2 class="module-title">剧本游戏上线审核控制台</h2>
        <span class="module-desc"
          >集中审核创作者提交的公测与正式版本资料包、谜题关卡与剧情合规性</span
        >
      </div>
      <div class="header-stats">
        <span class="stat-pill">当前标签共 {{ total }} 项记录</span>
      </div>
    </div>

    <!-- 表格与状态切换主卡片 -->
    <div class="audit-main-card">
      <el-tabs
        v-model="activeName"
        class="modern-audit-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane label="待审核列表" name="first"></el-tab-pane>
        <el-tab-pane label="已审核通过" name="second"></el-tab-pane>
        <el-tab-pane label="未通过驳回" name="third"></el-tab-pane>
      </el-tabs>

      <!-- 审核数据表格 -->
      <el-table
        :data="tableData"
        class="custom-audit-table"
        v-loading="loadingTable"
        style="width: 100%"
      >
        <el-table-column label="游戏封面" width="100">
          <template #default="{ row }">
            <el-image
              class="table-cover-img"
              :src="row.gameCover || defaultCover"
              fit="cover"
            />
          </template>
        </el-table-column>

        <el-table-column label="游戏标题" prop="gameTitle" min-width="180">
          <template #default="{ row }">
            <div class="table-title-cell">
              <span class="title-txt">{{ row.gameTitle || "未定名游戏" }}</span>
              <span class="author-txt"
                >By {{ row.author || "平台创作者" }}</span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column label="发布阶段" width="130">
          <template #default="{ row }">
            <el-tag
              :type="row.publicStatus === 1 ? 'primary' : 'warning'"
              effect="light"
              round
            >
              {{ row.publicStatus === 1 ? "正式上线" : "公测版本" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="模式" prop="gameClass" width="130" />
        <el-table-column label="语言" prop="gameLanguage" width="110" />

        <el-table-column label="价格" width="100">
          <template #default="{ row }">
            <span class="price-txt">
              {{ row.purchaseMoney ? `¥${row.purchaseMoney}` : "免费" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="提交时间" prop="createTime" width="170" />

        <el-table-column
          label="驳回原因"
          prop="remark"
          min-width="180"
          v-if="activeName === 'third'"
        >
          <template #default="{ row }">
            <span class="remark-rejected-txt">{{
              row.remark || "未填写原因"
            }}</span>
          </template>
        </el-table-column>

        <!-- 外层审核表格操作列 -->
        <el-table-column label="操作" width="120" align="right" fixed="right">
          <template #default="scope">
            <div class="table-actions-group">
              <!-- 跳转至对应的游戏封面编辑页面 -->
              <!--              <el-button-->
              <!--                type="default"-->
              <!--                size="small"-->
              <!--                class="jump-edit-btn"-->
              <!--                @click="jumpToEdit(scope.row.id)"-->
              <!--              >-->
              <!--                <el-icon><EditPen /></el-icon>-->
              <!--                编辑-->
              <!--              </el-button>-->

              <el-button
                v-if="activeName === 'first'"
                type="primary"
                size="small"
                class="audit-btn"
                @click="openAuditDialog(scope.row)"
              >
                审查详情
              </el-button>

              <el-popconfirm
                v-if="activeName === 'second'"
                title="确定要撤销该游戏的上线批准状态吗？"
                confirm-button-text="确定撤销"
                cancel-button-text="取消"
                confirm-button-type="danger"
                @confirm="quash(scope.$index, scope.row)"
              >
                <template #reference>
                  <el-button type="danger" plain size="small"
                    >撤销发布</el-button
                  >
                </template>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页 -->
      <div class="pagination-bar">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="currentPage"
          :page-size="10"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- ================= 核心结构化审核弹窗 ================= -->
    <el-dialog
      v-model="centerDialogVisible"
      title="剧本游戏上线合规审查"
      width="960px"
      class="custom-audit-dialog"
      destroy-on-close
      align-center
    >
      <div class="audit-dialog-body">
        <!-- 基础名片模块 -->
        <div class="audit-section">
          <div class="section-title">
            <span class="indicator"></span>
            <span>基础档案与商业配置</span>
          </div>

          <el-descriptions :column="3" border class="custom-descriptions">
            <el-descriptions-item label="游戏标题" :span="2">
              <strong>{{ form.gameTitle }}</strong>
            </el-descriptions-item>
            <el-descriptions-item label="体验定价">
              {{ form.purchaseMoney ? `${form.purchaseMoney} 元` : "免费" }}
            </el-descriptions-item>

            <el-descriptions-item label="创作者">
              {{ form.author || "未提供" }}
            </el-descriptions-item>
            <el-descriptions-item label="剧本模式">
              {{ form.gameClass || "-" }}
            </el-descriptions-item>
            <el-descriptions-item label="语言设定">
              {{ form.gameLanguage || "-" }}
            </el-descriptions-item>

            <el-descriptions-item label="游玩时长">
              {{ form.playTime || 0 }} 分钟
            </el-descriptions-item>
            <el-descriptions-item label="预计耗时">
              {{ form.estimateTime || "-" }}
            </el-descriptions-item>
            <el-descriptions-item label="适用年龄">
              {{ form.playerAge || "-" }}
            </el-descriptions-item>

            <el-descriptions-item label="起点描述">
              {{ form.beginPoint || "-" }}
            </el-descriptions-item>
            <el-descriptions-item label="终点描述" :span="2">
              {{ form.endPoint || "-" }}
            </el-descriptions-item>

            <el-descriptions-item label="开放时间" :span="3">
              {{ form.openHour || "全天开放" }} (体验建议:
              {{ form.experienceTime || "不限" }})
            </el-descriptions-item>

            <el-descriptions-item label="标签关键词" :span="3">
              <div class="chips-wrap">
                <el-tag
                  v-for="(tag, idx) in parsedTips"
                  :key="idx"
                  size="small"
                  class="tip-chip"
                >
                  {{ tag }}
                </el-tag>
                <span v-if="parsedTips.length === 0" class="empty-txt"
                  >未设置标签</span
                >
              </div>
            </el-descriptions-item>

            <el-descriptions-item label="剧情背景简介" :span="3">
              <p class="desc-cell-txt">
                {{ form.gameDesc || "未填写背景介绍" }}
              </p>
            </el-descriptions-item>

            <el-descriptions-item label="研学特色说明" :span="3">
              <p class="desc-cell-txt">
                {{ form.features || "未填写研学特色说明" }}
              </p>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 视觉与资源物料审查 -->
        <div class="audit-section">
          <div class="section-title">
            <span class="indicator"></span>
            <span>视觉资源与物料审查</span>
          </div>

          <div class="media-gallery-grid">
            <div class="media-card">
              <span class="media-name">游戏横版封面</span>
              <div class="media-box">
                <el-image
                  v-if="form.gameCover"
                  :src="form.gameCover"
                  fit="cover"
                  :preview-src-list="[form.gameCover]"
                  preview-teleported
                />
                <span v-else class="none-txt">未上传封面</span>
              </div>
            </div>

            <div class="media-card">
              <span class="media-name">游学结业证明图</span>
              <div class="media-box">
                <el-image
                  v-if="form.proveImg"
                  :src="form.proveImg"
                  fit="contain"
                  :preview-src-list="[form.proveImg]"
                  preview-teleported
                />
                <span v-else class="none-txt">无结业证书</span>
              </div>
            </div>

            <div class="media-card">
              <span class="media-name">手绘/自定义底图</span>
              <div class="media-box">
                <el-image
                  v-if="form.customizeMap"
                  :src="form.customizeMap"
                  fit="contain"
                  :preview-src-list="[form.customizeMap]"
                  preview-teleported
                />
                <span v-else class="none-txt">标准高德地图模式</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 深度内容快捷抽屉/弹窗通道 -->
        <div class="audit-section">
          <div class="section-title">
            <span class="indicator"></span>
            <span>深度剧情与核心关卡核查</span>
          </div>

          <div class="fast-actions-grid">
            <div class="fast-action-card" @click="showLevel2">
              <div class="action-info">
                <span class="title">开场叙事与序章</span>
                <span class="desc">核验初入游戏引导、开篇全屏立绘与说明</span>
              </div>
              <el-button type="primary" plain size="small">审查序章</el-button>
            </div>

            <div class="fast-action-card" @click="showLevel">
              <div class="action-info">
                <span class="title">关卡与谜题列表 ({{ form2.length }}关)</span>
                <span class="desc">逐关审查位置定位、线索提示图与选择谜题</span>
              </div>
              <el-button type="primary" plain size="small">审查关卡</el-button>
            </div>

            <div class="fast-action-card" @click="showLevel3">
              <div class="action-info">
                <span class="title">终局真相与复盘</span>
                <span class="desc">核验通关结局交付、复盘密钥与终章插图</span>
              </div>
              <el-button type="primary" plain size="small">审查终章</el-button>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer-actions">
          <el-button @click="centerDialogVisible = false">暂不处理</el-button>
          <el-button type="danger" plain @click="noPass"
            >不通过 · 驳回</el-button
          >
          <el-button type="primary" @click="pass" class="pass-confirm-btn">
            批准通过 · 立即发布
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 子弹窗：序章与开场审查 -->
    <el-dialog
      v-model="startVisible"
      title="开场序章剧情审查"
      width="600px"
      append-to-body
    >
      <div class="sub-dialog-content">
        <h4 class="sub-title">{{ form3.startTitle || "未定名序章标题" }}</h4>
        <p class="sub-desc">{{ form3.startContent || "暂无开场序言介绍" }}</p>
        <div class="sub-image-box" v-if="form3.startImg">
          <el-image
            :src="form3.startImg"
            fit="contain"
            :preview-src-list="[form3.startImg]"
            preview-teleported
          />
        </div>
      </div>
    </el-dialog>

    <!-- 子弹窗：终局复盘审查 -->
    <el-dialog
      v-model="endVisible"
      title="通关结局与复盘审查"
      width="600px"
      append-to-body
    >
      <div class="sub-dialog-content">
        <h4 class="sub-title">{{ form3.endTitle || "未定名通关结局" }}</h4>
        <p class="sub-desc">{{ form3.endContent || "暂无终章交代说明" }}</p>
        <div class="sub-image-box" v-if="form3.endImg">
          <el-image
            :src="form3.endImg"
            fit="contain"
            :preview-src-list="[form3.endImg]"
            preview-teleported
          />
        </div>
      </div>
    </el-dialog>

    <!-- 子弹窗：关卡详情折叠审查面板 -->
    <el-dialog
      v-model="levelVisible"
      width="820px"
      title="关卡线索与解谜全景审查"
      append-to-body
    >
      <div class="level-audit-scroll">
        <el-collapse v-if="form2 && form2.length > 0">
          <el-collapse-item
            v-for="(item, idx) in form2"
            :key="idx"
            :title="`第 ${idx + 1} 关：${item.levelTitle || '未命名关卡'}`"
            :name="idx"
          >
            <div class="level-detail-block">
              <!-- 定位与提示 -->
              <div class="sub-grid-2">
                <p>
                  <strong>实地地点：</strong
                  >{{ item.address || "未设置实景地标" }}
                </p>
                <p>
                  <strong>坐标：</strong>Lat: {{ item.lat }} , Lng:
                  {{ item.lng }}
                </p>
              </div>

              <div class="tip-content-box" v-if="item.addressTipContent">
                <span class="box-tag">地点寻找线索</span>
                <p>{{ item.addressTipContent }}</p>
              </div>

              <!-- 提示图列表 -->
              <div class="sub-imgs-row" v-if="item.tipCover">
                <span class="row-label">关卡提示图：</span>
                <el-image
                  v-for="(imgUrl, i) in splitImages(item.tipCover)"
                  :key="i"
                  :src="imgUrl"
                  fit="cover"
                  class="thumb-box"
                  :preview-src-list="splitImages(item.tipCover)"
                  preview-teleported
                />
              </div>

              <!-- 题目与选项审查 -->
              <div class="questions-audit-card" v-if="item.questions">
                <span class="card-title">互动谜题与选项核验</span>
                <div
                  v-for="(qItem, qIdx) in safeParseQuestions(item.questions)"
                  :key="qIdx"
                  class="question-unit"
                >
                  <p class="q-title">
                    <strong>题{{ qIdx + 1 }}:</strong> {{ qItem.value }}
                  </p>
                  <p class="q-answer">
                    <strong>正确答案:</strong>
                    <span class="right-ans">{{ qItem.rightAnswer }}</span>
                  </p>
                  <div class="options-list">
                    <span
                      v-for="(opt, optIdx) in qItem.options"
                      :key="optIdx"
                      class="opt-item"
                    >
                      {{ optIdx + 1 }}. {{ opt.one }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="level-footer-actions">
                <el-button
                  type="info"
                  size="small"
                  plain
                  @click="showTips(item.tips)"
                  v-if="item.tips"
                >
                  查看该关卡求助线索 (Tips)
                </el-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-empty v-else description="该游戏暂未录入任何关卡数据" />
      </div>
    </el-dialog>

    <!-- 子弹窗：线索提示清单 -->
    <el-dialog
      v-model="tipVisible"
      width="560px"
      title="关卡求助锦囊 (Tips)"
      append-to-body
    >
      <div class="tips-audit-list">
        <div v-for="(tip, tIdx) in form4" :key="tIdx" class="tip-audit-card">
          <h5 class="tip-title">锦囊 {{ tIdx + 1 }}：{{ tip.tipTitle }}</h5>
          <p class="tip-txt">{{ tip.tipContent }}</p>
          <div class="tip-img-box" v-if="tip.tipPicture">
            <el-image
              :src="tip.tipPicture"
              fit="contain"
              :preview-src-list="[tip.tipPicture]"
              preview-teleported
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="zhanwei3"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ElMessageBox, ElMessage, TabsPaneContext } from "element-plus";
import { EditPen } from "@element-plus/icons-vue";
import { Form } from "@/views/view";

export default defineComponent({
  name: "GameAuditManager",
  components: {
    EditPen,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      activeName: "first",
      loadingTable: false,
      tableData: [] as any[],
      status: 0,
      centerDialogVisible: false,
      levelVisible: false,
      startVisible: false,
      endVisible: false,
      tipVisible: false,
      defaultCover:
        "https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493",
      form: {} as any,
      form2: [] as any[],
      form3: {
        createTime: "",
        endContent: "",
        endImg: "",
        endTitle: "",
        gameId: "",
        id: "",
        startContent: "",
        startImg: "",
        startTitle: "",
      },
      form4: [] as any[],
    };
  },
  computed: {
    parsedTips(): string[] {
      if (!this.form?.tips) return [];
      try {
        const res =
          typeof this.form.tips === "string"
            ? JSON.parse(this.form.tips)
            : this.form.tips;
        return Array.isArray(res) ? res : [];
      } catch (e) {
        return [];
      }
    },
  },
  created() {
    this.fetchGameList(this.currentPage, this.status);
  },
  methods: {
    fetchGameList(pageNum: number, status: number) {
      this.loadingTable = true;
      const pageSize = 10;
      this.$store
        .dispatch("game/getGameList2", { pageNum, pageSize, status })
        .then((res: any) => {
          this.tableData = res.records || [];
          this.total = res.total || 0;
        })
        .catch(() => {
          ElMessage.error("获取审核列表失败");
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },

    handleCurrentChange(val: number) {
      this.currentPage = val;
      this.fetchGameList(val, this.status);
    },

    handleClick(tab: TabsPaneContext) {
      this.status =
        tab.paneName === "first" ? 0 : tab.paneName === "second" ? 1 : 2;
      this.currentPage = 1;
      this.fetchGameList(1, this.status);
    },

    // 快速在新标签页打开编辑页面
    jumpToEdit(gameId: string | number) {
      if (!gameId) {
        ElMessage.warning("游戏ID不存在，无法跳转");
        return;
      }
      const routeUrl = this.$router.resolve({
        path: `/edit/${gameId}/cover`,
      });
      window.open(routeUrl.href, "_blank");
    },

    openAuditDialog(row: Form) {
      this.form = { ...row };
      this.centerDialogVisible = true;
      if (this.form.gameLevelId) {
        this.$store
          .dispatch("game/getGameLevelList2", {
            gameLevelId: this.form.gameLevelId,
          })
          .then((res: any) => {
            this.form2 = Array.isArray(res) ? res : [];
          })
          .catch(() => {});
      }
    },

    showLevel() {
      this.levelVisible = true;
    },

    showLevel2() {
      this.startVisible = true;
      this.$store
        .dispatch("game/getStory2", { gameId: this.form.id })
        .then((res: any) => {
          this.form3 = res || {};
        })
        .catch(() => {});
    },

    showLevel3() {
      this.endVisible = true;
      this.$store
        .dispatch("game/getStory2", { gameId: this.form.id })
        .then((res: any) => {
          this.form3 = res || {};
        })
        .catch(() => {});
    },

    showTips(tips: string) {
      this.tipVisible = true;
      this.$store
        .dispatch("game/getTipList2", { tips })
        .then((res: any) => {
          this.form4 = Array.isArray(res) ? res : [];
        })
        .catch(() => {});
    },

    noPass() {
      ElMessageBox.prompt(
        "请输入不予通过的详细审核意见与驳回原因",
        "审核驳回",
        {
          confirmButtonText: "确定驳回",
          cancelButtonText: "取消",
          inputPattern: /\S+/,
          inputErrorMessage: "驳回原因不可为空",
        }
      )
        .then(({ value }) => {
          this.updateGame(this.form.id, 2, value);
        })
        .catch(() => {});
    },

    pass() {
      ElMessageBox.confirm(
        `确认批准上线游戏《${
          this.form.gameTitle || "未定名"
        }》吗？通过后将正式向玩家开放！`,
        "确认通过",
        {
          confirmButtonText: "确认发布",
          cancelButtonText: "取消",
          type: "success",
        }
      )
        .then(() => {
          this.updateGame(this.form.id, 1, "");
        })
        .catch(() => {});
    },

    quash(index: number, row: Form) {
      this.updateGame(row.id, 0, "管理员撤回已发布状态");
    },

    updateGame(releaseId: string, status: number, remark = "") {
      this.$store
        .dispatch("game/updateRelease", { releaseId, status, remark })
        .then(() => {
          ElMessage.success("审核状态已更新");
          this.centerDialogVisible = false;
          this.fetchGameList(this.currentPage, this.status);
        })
        .catch((err: any) => {
          ElMessage.error("操作失败: " + (err.message || "系统繁忙"));
        });
    },

    splitImages(str: string): string[] {
      if (!str) return [];
      return str.split(",").filter(Boolean);
    },

    safeParseQuestions(jsonStr: string): any[] {
      if (!jsonStr) return [];
      try {
        const res = JSON.parse(jsonStr);
        return Array.isArray(res) ? res : [];
      } catch (e) {
        return [];
      }
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-hover: #4b4de0;
@primary-light: #f0f2ff;
@text-main: #0f172a;
@text-sub: #475569;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.zhanwei4 {
  height: 20px;
}
.zhanwei3 {
  height: 32px;
}

.audit-manager-container {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 顶部信息栏
.audit-header-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .header-left {
    .module-title {
      font-size: 18px;
      font-weight: 700;
      color: @text-main;
      margin: 0 0 4px 0;
    }
    .module-desc {
      font-size: 12.5px;
      color: @text-muted;
    }
  }

  .header-stats {
    .stat-pill {
      font-size: 12px;
      font-weight: 600;
      color: @primary-color;
      background: @primary-light;
      padding: 4px 12px;
      border-radius: 20px;
    }
  }
}

// 主白底卡片
.audit-main-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid @card-border;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.03);
  padding: 20px 24px 28px;

  .modern-audit-tabs {
    margin-bottom: 16px;

    :deep(.el-tabs__item) {
      font-size: 14px;
      font-weight: 600;
      color: @text-sub;
      transition: color 0.2s;

      &.is-active {
        color: @primary-color;
        font-weight: 700;
      }
    }
    :deep(.el-tabs__active-bar) {
      background-color: @primary-color;
      height: 3px;
    }
  }
}

// 表格与操作列
.custom-audit-table {
  .table-cover-img {
    width: 60px;
    height: 45px;
    border-radius: 6px;
    display: block;
    background: #f1f5f9;
  }

  .table-title-cell {
    display: flex;
    flex-direction: column;

    .title-txt {
      font-weight: 700;
      color: @text-main;
      font-size: 13.5px;
      line-height: 1.4;
    }

    .author-txt {
      font-size: 11.5px;
      color: @text-muted;
    }
  }

  .price-txt {
    font-weight: 700;
    color: #059669;
  }

  .remark-rejected-txt {
    color: @danger-color;
    font-size: 12px;
  }

  .table-actions-group {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .jump-edit-btn {
    border-color: #cbd5e1;
    color: #475569;
    font-weight: 500;

    .el-icon {
      margin-right: 4px;
    }

    &:hover {
      color: @primary-color;
      border-color: @primary-color;
      background-color: @primary-light;
    }
  }

  .audit-btn {
    background-color: @primary-color;
    border-color: @primary-color;
    font-weight: 600;

    &:hover {
      background-color: @primary-hover;
      border-color: @primary-hover;
    }
  }
}

.pagination-bar {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

// 核心审核弹窗
.custom-audit-dialog {
  :deep(.el-dialog__header) {
    border-bottom: 1px solid @border-color;
    margin: 0;
    padding: 16px 24px;
  }

  .audit-dialog-body {
    max-height: 68vh;
    overflow-y: auto;
    padding-right: 8px;

    .audit-section {
      margin-bottom: 24px;

      .section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 700;
        color: @text-main;

        .indicator {
          width: 3.5px;
          height: 15px;
          background: @primary-color;
          border-radius: 2px;
        }
      }
    }
  }

  .custom-descriptions {
    :deep(.el-descriptions__label) {
      width: 100px;
      font-weight: 600;
      color: @text-sub;
      background: #f8fafc;
    }
  }

  .chips-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;

    .tip-chip {
      background: @primary-light;
      color: @primary-color;
      border-color: #dce2ff;
      font-weight: 600;
    }
    .empty-txt {
      font-size: 12px;
      color: @text-muted;
    }
  }

  .desc-cell-txt {
    margin: 0;
    font-size: 12.5px;
    color: @text-sub;
    line-height: 1.6;
    white-space: pre-wrap;
  }

  // 视觉物料展示网格
  .media-gallery-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .media-card {
      background: #f8fafc;
      border: 1px solid @border-color;
      border-radius: 10px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .media-name {
        font-size: 12.5px;
        font-weight: 600;
        color: @text-sub;
        margin-bottom: 8px;
      }

      .media-box {
        width: 100%;
        height: 140px;
        border-radius: 6px;
        background: #ffffff;
        border: 1px dashed @border-color;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        .el-image {
          width: 100%;
          height: 100%;
          cursor: zoom-in;
        }

        .none-txt {
          font-size: 11.5px;
          color: @text-muted;
        }
      }
    }
  }

  // 深度通道卡片
  .fast-actions-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .fast-action-card {
      background: #ffffff;
      border: 1px solid @border-color;
      border-radius: 10px;
      padding: 14px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 10px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        border-color: @primary-color;
        box-shadow: 0 4px 12px rgba(93, 95, 239, 0.1);
      }

      .action-info {
        .title {
          font-size: 13.5px;
          font-weight: 700;
          color: @text-main;
          display: block;
          margin-bottom: 4px;
        }
        .desc {
          font-size: 11.5px;
          color: @text-muted;
          line-height: 1.4;
          display: block;
        }
      }
    }
  }

  .dialog-footer-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .pass-confirm-btn {
      background-color: @primary-color;
      border-color: @primary-color;
      font-weight: 600;

      &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
      }
    }
  }
}

// 关卡审核折叠面板
.level-audit-scroll {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 6px;

  .level-detail-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 6px 0;

    .sub-grid-2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      font-size: 12.5px;
      color: @text-sub;
      margin: 0;

      p {
        margin: 0;
      }
    }

    .tip-content-box {
      background: #f8fafc;
      padding: 10px 12px;
      border-radius: 6px;
      border-left: 3px solid @primary-color;

      .box-tag {
        font-size: 11px;
        font-weight: 700;
        color: @primary-color;
        display: block;
        margin-bottom: 4px;
      }

      p {
        margin: 0;
        font-size: 12px;
        color: @text-sub;
      }
    }

    .sub-imgs-row {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;

      .row-label {
        font-size: 12px;
        font-weight: 600;
        color: @text-sub;
      }

      .thumb-box {
        width: 60px;
        height: 60px;
        border-radius: 6px;
        border: 1px solid @border-color;
        cursor: zoom-in;
      }
    }

    .questions-audit-card {
      background: #fdfdfd;
      border: 1px solid #f1f5f9;
      border-radius: 8px;
      padding: 12px;

      .card-title {
        font-size: 12px;
        font-weight: 700;
        color: @text-main;
        display: block;
        margin-bottom: 8px;
      }

      .question-unit {
        margin-bottom: 8px;
        padding-bottom: 8px;
        border-bottom: 1px dashed #e2e8f0;

        p {
          margin: 0 0 4px 0;
          font-size: 12px;
        }

        .right-ans {
          color: #059669;
          font-weight: 700;
        }

        .options-list {
          display: flex;
          gap: 12px;
          font-size: 11.5px;
          color: @text-muted;
        }
      }
    }

    .level-footer-actions {
      display: flex;
      justify-content: flex-end;
    }
  }
}

// 子弹窗共用
.sub-dialog-content {
  .sub-title {
    font-size: 16px;
    font-weight: 700;
    color: @text-main;
    margin: 0 0 8px 0;
  }
  .sub-desc {
    font-size: 13px;
    color: @text-sub;
    line-height: 1.6;
    margin: 0 0 16px 0;
    white-space: pre-wrap;
  }
  .sub-image-box {
    width: 100%;
    max-height: 280px;
    display: flex;
    justify-content: center;
    background: #f8fafc;
    border-radius: 8px;
    padding: 12px;
    overflow: hidden;

    .el-image {
      max-height: 260px;
    }
  }
}

.tips-audit-list {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .tip-audit-card {
    background: #f8fafc;
    border-radius: 8px;
    padding: 12px 14px;
    border: 1px solid @border-color;

    .tip-title {
      margin: 0 0 6px 0;
      font-size: 13px;
      font-weight: 700;
      color: @text-main;
    }

    .tip-txt {
      margin: 0 0 8px 0;
      font-size: 12px;
      color: @text-sub;
      line-height: 1.5;
    }

    .tip-img-box {
      width: 120px;
      height: 80px;
      border-radius: 4px;
      overflow: hidden;
    }
  }
}
</style>
